import { useEffect } from "react";

import { Icon } from "./Icon";
import { TOOLS } from "./ToolRail";

const GROUPS: Array<{ title: string; items: Array<[string, string]> }> = [
  {
    title: "ツール",
    items: [
      ...TOOLS.map((tool): [string, string] => [tool.shortcut, tool.label]),
      ["O", "図形（円）"],
      ["[ / ]", "ペン・消しゴムを細く／太く"],
    ],
  },
  {
    title: "編集",
    items: [
      ["Ctrl/⌘ + Z", "元に戻す"],
      ["Ctrl/⌘ + Shift + Z", "やり直す"],
      ["Ctrl/⌘ + C / V", "範囲をコピー／貼り付け"],
      ["Ctrl/⌘ + D", "範囲を複製"],
      ["Ctrl/⌘ + A", "すべての範囲を選択"],
      ["Delete", "範囲を削除"],
      ["矢印キー", "範囲を移動（Shift で 10px）"],
      ["Shift + ドラッグ", "正方形・正円で描く／縦横比を保って変形"],
      ["Enter / Esc", "多角形を完成／やめる"],
    ],
  },
  {
    title: "表示",
    items: [
      ["Space + ドラッグ", "画面を動かす"],
      ["Ctrl/⌘ + ホイール", "ズーム"],
      ["Ctrl/⌘ + 0", "画面に合わせる"],
      ["C（押している間）", "元の画像と比較"],
      ["P", "プレビュー"],
      ["← / →", "前／次の画像"],
      ["Ctrl/⌘ + S", "ダウンロード"],
    ],
  },
];

export function ShortcutsDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  useEffect(() => {
    if (!open) return;
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose, open]);

  if (!open) return null;
  return (
    <div
      className="modal-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (event.currentTarget === event.target) onClose();
      }}
    >
      <section
        className="shortcuts-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="shortcuts-title"
      >
        <div className="dialog-heading">
          <h2 id="shortcuts-title">キーボードショートカット</h2>
          <button className="icon-button" type="button" aria-label="閉じる" onClick={onClose}>
            <Icon name="close" size={18} />
          </button>
        </div>
        <div className="shortcut-groups">
          {GROUPS.map((group) => (
            <section key={group.title}>
              <h3>{group.title}</h3>
              <dl>
                {group.items.map(([keys, label]) => (
                  <div key={label}>
                    <dt>{label}</dt>
                    <dd>
                      <kbd>{keys}</kbd>
                    </dd>
                  </div>
                ))}
              </dl>
            </section>
          ))}
        </div>
      </section>
    </div>
  );
}
